module.exports = __webpack_public_path__ + "media/images/athletes/3578-b285057fcf599d21d67ded948d4654ab.png";